<template>
    <div id="oportunity-description">
        <div class="section section-padding" id="section1">
            <div class="container">
                <div class="section-heading heading-left">
                    <span class="subtitle emerge-red bold">EMERGE.</span>
                    <h2 class="title">Factores <span class="bold">clave</span> de esta oportunidad.</h2>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-6" data-sal="slide-up" data-sal-duration="800" data-sal-delay="100">
                        <div class="services-grid service-style-2 emerge">
                            <div class="thumbnail">
                                <img :src="`${iconBase}-01.png`" alt="icon">
                            </div>
                            <div class="content">
                                <h5 class="title white">Bajemos las tarifas.</h5>
                                <p class="white mb-0">
                                    Los consumidores en México
                                    pagan las tarifas energéticas
                                    comerciales y domésticas
                                    más altas entre los países
                                    de la OCDE.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6" data-sal="slide-up" data-sal-duration="800" data-sal-delay="200">
                        <div class="services-grid service-style-2 emerge">
                            <div class="thumbnail">
                                <img :src="`${iconBase}-02.png`" alt="icon">
                            </div>
                            <div class="content">
                                <h5 class="title white">Un gran potencial.</h5>
                                <p class="white mb-0">
                                    La radiación solar en México
                                    está calificada como una
                                    de las de mayor potencial
                                    en el mundo.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6" data-sal="slide-up" data-sal-duration="800" data-sal-delay="300">
                        <div class="services-grid service-style-2 emerge">
                            <div class="thumbnail">
                                <img :src="`${iconBase}-03.png`" alt="icon">
                            </div>
                            <div class="content">
                                <h5 class="title white">Energía para todos.</h5>
                                <p class="white mb-0">
                                    El costo de los sistemas
                                    solares (sin baterías) ha ido
                                    disminuyendo durante
                                    los últimos años y actualmente
                                    existen algunos incentivos
                                    fiscales a la importación.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--=====================================-->
        <!--=        Project Area Start         =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div id="oportunity-banner" class="project-add-banner bg-color-mercury mb--50" data-sal="slide-up" data-sal-duration="1000" >
                    <div class="content">
                        <div class="row">
                            <div class="col-sm-12 col-md-7 col-lg-7">
                                <h5 class="emerge-red bold mb-2">Nuestra contribución.</h5>
                                <h2 class="black">
                                    Reduce emisiones
                                    de CO<sub>2</sub> y <span class="bold">combate</span> <span class="bold">el cambio climático.</span>
                                </h2>
                                <p class="black h6">Con este proyecto se pretende contribuir al objetivo
                                    de reducción de emisiones para 2030 de Coca-Cola FEMSA
                                    mitigando una importante fuente de emisiones: la electricidad
                                    consumida por los equipos de refrigeración en las
                                    instalaciones de las PyMEs.</p>
                            </div>
                            <div class="col-sm-hidden col-md-4 col-4">
                                <!-- TODO -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "OportunityDescriprion",
        data: () => ({
            iconBase: "https://cdn.redgirasol.com/nuevo_portal/emerge/icons/icon-card"
        }),
        props: {
            source: String
        }
    }
</script>

<style>
.emerge {
    background: var(--color-black) !important;
    color: var(--color-white) !important;
    min-height: 21rem;
}

.emerge .content p {
    text-overflow: unset !important;
    display: block !important;
}

#oportunity-banner {
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/emerge/banners/emerge-banner-02.png");
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #f1f1f1 !important;
}

@media (max-width: 750px){
    #oportunity-banner {
        background-position: bottom;
    }
}

</style>